import React, { FC } from 'react';
import { FaWindowClose } from 'react-icons/fa';
import { IconProps } from './common/iconProps';

export const CloseIcon:
FC<IconProps> = ({ className }) => <FaWindowClose className={className} />;
